export const search_list = [
  {
    type: "input",
    label: "公司名称",
    props: 'company_name',
  },
  {
    type: 'select',
    label: '保险类型',
    props: 'type',
    selectData: [
      {
        label: '雇主责任险',
        value: '雇主责任险'
      },
      {
        label: '灵活用工意外险',
        value: '灵活用工意外险'
      }
    ]
  }
];

export const tableColumns = [
  {
    title: "企业名称",
    value: 'company_name',
    header_align: 'center',
    align: 'center'
  },
  {
    title: "保险套餐名称",
    value: 'product_type',
    header_align: 'center',
    align: 'center'
  },
  {
    title: "保险产品名称",
    value: 'product_name',
    header_align: 'center',
    align: 'center'
  },
  {
    title: '职业类型',
    value: 'job_level_text',
    header_align: 'center',
    align: 'center'
  },
  {
    title: "保费(单位元)",
    value: "product_premium",
    header_align: 'center',
    align: 'center'
  },
  {
    title: "保额(单位元)",
    value: "product_sum_insured",
    header_align: 'center',
    align: 'center'
  },
  {
    title: "投保场景打卡模式",
    value: "clock_mode_text",
    header_align: 'center',
    align: 'center'
  }
];
export const actionGroup = [
  {
    name: "查看",
    flag: "show",
  }
];

export const form_list = [
  {
    type: "input",
    label: "姓名",
    props: "cert_name",
    disabled: true,
  },
  {
    type: "input",
    label: "手机号",
    props: "phone",
    disabled: true,
  },
  {
    type: "input",
    label: "投保场景",
    props: "is_clock_work",
    disabled: true,
  },
  {
    type: "input",
    label: "保单凭证号",
    props: "policy_no",
    disabled: true,
  },
  {
    type: "input",
    label: "生效时间",
    props: "effect_start_time",
    disabled: true,
  },
  {
    type: "input",
    label: "失效时间",
    props: "effect_end_time",
    disabled: true,
  },
  {
    type: "input",
    label: "保费",
    props: "premium",
    disabled: true,
    append: "元"
  },
  {
    type: "input",
    label: "保额",
    props: "sum_insured",
    disabled: true,
    append: "元"
  },
  {
    type: "input",
    label: "保单状态",
    props: "policy_status",
    disabled: true,
  },
  {
    type: "input",
    label: "退保金额",
    props: "surrender_amount",
    disabled: true,
    append: "元"
  },
  {
    type: "input",
    label: "退保时间",
    props: "surrender_time",
    disabled: true,
  },
];
